import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { IconPlus } from '@tabler/icons-react'
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import GalleryItem from "./GalleryItem";
import NewGallery from "./NewGaller";


const GalleryParent = forwardRef(
  function GalleryParent(props, ref) {
    
    const [peoples, setPeoples] = useState([]);
        const imageRef = useRef();
    
console.log("peoples",peoples)
    useEffect(() => {
      if (props.data) {
        setPeopleData(props.data);
      }
    }, [props.data]);

    const setPeopleData = (data) => {
      let peoplesData = [];
      data.forEach((item, index) => {
        peoplesData.push({
          name: item.name,
          relationship: item.relationship,
          image: item.image,
          imageFile: item.imageFile,
          imageKey: item.imageKey,
          show: index == 0,
          isValid: false,
          ref: null
        })
      });

      setPeoples(peoplesData);
    }

    const handleAddPeople = () => {
      let people =
      {
        name: "Person " + (peoples.length + 1),
        relationship: "",
        image: null,
        imageFile: null,
        show: peoples.length == 0,
        isValid: false,
        ref: null,
        imageKey: ""
      }

      setPeoples([...peoples, people]);
    }

    const showHidePople = (index) => {
      const currentPeople = [...peoples];

      currentPeople.forEach((people, innerIndex) => {
        if (index == innerIndex)
          people["show"] = !people["show"];
        else
          people["show"] = false;
      });

      setPeoples(currentPeople);
    }

    const deletePeopleHandler = (targetIndex) => {
      const filteredPeoples = peoples.filter((item, index) => index !== targetIndex);

      if (filteredPeoples.length == 1) {
        filteredPeoples[0]["show"] = true;
      }

      const deletedPeople = peoples.filter((item, index) => index === targetIndex);

      if (deletedPeople && deletedPeople.length > 0) {
        if (deletedPeople[0].imageKey != "")
          props.imageDelete(deletedPeople[0].imageKey);
      }

      setPeoples(filteredPeoples);
    }

    const imageDeleteHandler = (imageKey) => {
      props.imageDelete(imageKey);
    }

    console.log(peoples)
    const validate = () => {
      let isValid = true;
      const currentPeoples = [...peoples];
      currentPeoples.forEach(people => {
        let validationStatus = people.ref?.validate() ?? false;
        people["isValid"] = validationStatus;

        if (!validationStatus) {
          isValid = false;
        }
      });
      setPeoples(currentPeoples);
      return isValid;
    }

    // const getData = () => {
    //   let peopleData = [];

    //   peoples.forEach(people => {
    //     let data = people.ref?.getData() ?? null;
    //     if (data)
    //       peopleData.push(data);
    //   });
    //   return peopleData;
    // }
    const getData = () => {
      return {
        image: imageRef?.current?.getData() ?? null,
        imageFile: imageRef?.current?.getData() ?? null,
      }
    }
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">Gallery Details</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right">
            {/* <button className="btn btn-primary align-middle" onClick={handleAddPeople}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Category
            </button> */}
          </div>
        </div>
        <div className="row g-3">
        <NewGallery ref={imageRef}
                />          
                {/* <div className="accordion mt-3">
            {
              (!peoples || (peoples && peoples.length == 0)) && (
                <div className="row justify-content-center">
                  <div className="col-md-5 col-lg-4 col-11">
                    <div className="d-flex flex-column align-items-center">
                      <img src="/images/people.svg" />
                      <div className="helper-message">
                        No category information<br /> Get started by creating
                      </div>
                      <button type="button" className="mt-2 btn btn-primary btn btn-secondary" onClick={handleAddPeople}>
                        <IconPlus className="me-sm-1 me-0" size={20} />
                        Add Category
                      </button>
                    </div>
                  </div>
                </div>
              )
            }

            {peoples && peoples.length > 0 &&
              peoples.map((people, index) => {
                return (
                  <GalleryItem
                    data={people}
                    index={index}
                    showHidePople={showHidePople}
                    deletePeople={deletePeopleHandler}
                    imageDelete={imageDeleteHandler}
                    key={index}
                    ref={el => people.ref = el} />
                ) 
              })
            }
          </div> */}

          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </div>
      </div>
    )
  });

export default GalleryParent;
